import { render, staticRenderFns } from "./hallOfFameEditForm.vue?vue&type=template&id=05888701&"
import script from "./hallOfFameEditForm.vue?vue&type=script&lang=js&"
export * from "./hallOfFameEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports